import React from 'react';
import { styled } from '@compiled/react';
import { Section } from '@atlaskit/menu';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy, LazyWait } from '@atlassian/react-loosely-lazy';
import { MenuLayout } from '../../../common/ui/menu/layout/index.tsx';
import { MenuSkeletonContent } from '../../../common/ui/menu/skeleton/content/main.tsx';

interface Props {
	shouldLoad: boolean;
}

const Skeleton = () => (
	<MenuLayout isWide>
		<AppsSectionWrapper>
			<MenuSkeletonContent />
		</AppsSectionWrapper>
	</MenuLayout>
);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyMenu = lazy(
	() => import(/* webpackChunkName: "async-addons-menu" */ './index').then((module) => module.Menu),
	{
		ssr: false,
	},
);

export const AsyncMenu = ({ shouldLoad = true }: Props) => (
	<LazyWait until={shouldLoad}>
		<Placeholder fallback={<Skeleton />} name="lazy-menu">
			<LazyMenu />
		</Placeholder>
	</LazyWait>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const AppsSectionWrapper = styled(Section)({
	minHeight: '50px',
});
